<ejs-grid #grid
          class="grid-with-toolbar grid-with-footer"
          width="100%"
          rowHeight="38"
          [dataSource]="data"
          [allowSorting]="true"
          [filterSettings]="filterSettings"
          [allowFiltering]="true"
          [allowPaging]="true"
          [pageSettings]="pageSettings"
          [editSettings]="editSettings"
          [searchSettings]="searchOptions"
          (actionBegin)="actionBegin($event)"
          (actionComplete)="actionComplete($event)">
  <e-columns>
    <e-column type='checkbox' width='40' [showInColumnChooser]="false"></e-column>
    <e-column field="id"
              [visible]="false"
              [isPrimaryKey]="true"></e-column>
    <e-column field="name"
              type="string"
              headerText="{{'i18n.domain.third-party-user-assignment-administration.grid.zoneName' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="{{zonePathFieldName}}"
              [allowFiltering]="false"
              [allowSorting]="false"
              type="string"
              headerText="{{'i18n.domain.third-party-user-assignment-administration.grid.zonePath' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
  </e-columns>
</ejs-grid>
